import { useContext, useEffect } from "react";
import { ToolContext } from "../../../../context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const CategoryWalkthrough = ({ pathname, end, start}) => {

    const {personalization_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state
    
    const startTour = () =>{
        walkthrough.set((prev) => ({...prev, createCategory:true}))
    }

    const endTour = ()=>{
        walkthrough.set((prev) => ({...prev, createCategory:false}))
    }

    useEffect(() => {
        start("setup", "category-setup", startTour)
        //eslint-disable-next-line
    }, []);

    const steps =[
            {
                content: "Insert Category Name",
                placement: "right",
                target: "#walkthrough-category-step-1",
                disableBeacon: true,
            },
            {
                content: "Insert Sub-category Name  ",
                placement: "right",
                target: "#walkthrough-category-step-2",
                disableBeacon: true
            },
            {
                content: "You can click the plus button to add more sub-categories",
                placement: "right",
                target: "#walkthrough-category-step-3",
                disableBeacon: true
            },
            {
                content: "Click this to add more categories",
                placement: "right",
                target: "#walkthrough-category-step-4",
                disableBeacon: true
            },
            {
                content: "Once done, click Save to create the category",
                placement: "right",
                target: "#walkthrough-category-step-5",
                disableBeacon: true
            },
        ]

    return (
        <JoyrideWrapper 
            run={walkthrough.data.createCategory && window.location.pathname === pathname} 
            steps={steps} 
            setter={endTour} 
            end={end}
            p_name="category-setup" 
            featureName="setup"
        />
    );
}